import { render, staticRenderFns } from "./AllergensBlock.vue?vue&type=template&id=4c4f24a6&lang=pug&"
import script from "./AllergensBlock.vue?vue&type=script&lang=js&"
export * from "./AllergensBlock.vue?vue&type=script&lang=js&"
import style0 from "./AllergensBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports